export default __webpack_public_path__ + "static/media/rareaLogo.2851c609.glb";